/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import delayAnalysisFields from "../store/constants/delayAnalysisFields"
import { setGraph, setJobstreamData } from "../store/slice/roomSlices/delayAnalysisRoomSlice";
import store from "../store/store";

export const updateDelayAnalysisRoom = (path, data) => {
    const dispatch = store.dispatch;
    const keys = path.split("/:");
    const root = keys[0];
    const jobId = keys[1];
    const field = keys[2];

    switch (root) {
        case delayAnalysisFields.JOBSTREAM_DATA:
            dispatch(setJobstreamData({ jobId, field, data }))
            break;

        case delayAnalysisFields.GRAPH:
            dispatch(setGraph(data))
            break;

        default:
            console.log("case: ", root, "not yet implemented");
            break;
    }
};